import React from 'react';
import {
    Button,
    Card,
    CardBody,
    Col,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Table
} from 'reactstrap';
import BaseComponent from '../BaseComponent';
import PropTypes from 'prop-types';
// import label from '../../message/Label'
import label from 'enqc-utilities/src/label/Label'
import {isEmpty} from "../../utils/Utilities";
import ModalCardHeader from "../Widget/ModalCardHeader";

const { htmlToText } = require('html-to-text');

/*= (message, okCallback, cancelCallback) =>*/
export default class RectifierControllerSerialNumberInfoModal extends BaseComponent{

    constructor(props){
        super(props);
        let state = this.state
        let {inspection, showing} = this.props
        if(!inspection){
            inspection = {}
        }
        let assembly = inspection.assembly??{}
        state.inspection = inspection
        state.showing = showing
        this.setState(state)
    }

    componentWillReceiveProps(props, nextContext) {
        if(this.props!=props){
            let inspection = props.inspection??{}
            if(!inspection){
                inspection = {}
            }
            this.setState({
                inspection,
                showing:props.showing,
            })
        }
    }

    render(){
        let {showing, inspection} = this.state
        if(!inspection){
            inspection = {}
        }
        let {model} = inspection
        if(!model){
            model = {}
        }
        let currentInspectionEvent = inspection.currentInspectionEvent??{}
        let {assembly} = inspection
        let rectifierControllerSerialNumbers = []
        if(assembly && assembly.id) {
            let {rectifierControllerEntry} = assembly
            if (!rectifierControllerEntry) {
                rectifierControllerEntry = {}
            }
            rectifierControllerSerialNumbers = rectifierControllerEntry.rectifierControllerSerialNumbers ?? []
        }

        if(rectifierControllerSerialNumbers.length==0 && currentInspectionEvent.rectifierControllerSerialNumbers){
            rectifierControllerSerialNumbers = currentInspectionEvent.rectifierControllerSerialNumbers
        }


        return (
            /*xl-lg-sm*/
            <Modal
                autoFocus={false}
                size="xl"
                centered={true}
                isOpen={showing}
                backdrop={true}>
                {super.render()}
                <ModalCardHeader
                    content={(
                        <React.Fragment>
                            <h3 style={{display:'contents'}}>{label.RectifierControllerSerialNumber}</h3>
                            <div
                                style={{float:"right", textAlign:'right'}}>
                                <Button
                                    color="white"
                                    className="float-right btn-outline-black"
                                    onClick={() => {
                                        this.props.onClose()
                                    }}>{label.Close}</Button>
                            </div>
                        </React.Fragment>
                    )}/>
                <ModalBody>
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <FormGroup>
                                        <Label for="adminCode">{label.FWVersion}</Label>
                                        <Input
                                            type="text"
                                            name="fwVersion"
                                            value={inspection.fwVersion}
                                            disabled={true}/>
                                    </FormGroup>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col>
                            <Card>
                                <CardBody>
                                    <FormGroup>
                                        <Label for="adminCode">{label.Controller}</Label>
                                        <Input
                                            type="text"
                                            name="controller"
                                            value={inspection.controller}
                                            disabled={true}/>
                                    </FormGroup>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col>
                            <Card className="p-0">
                                <CardBody className="p-0">
                                    <Table responsive hover>
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{label.Index}</th>
                                            <th>{label.Value}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            rectifierControllerSerialNumbers.map((item, index)=>(
                                                <>
                                                    <tr key={item.id} style={{borderBottom:(!isEmpty(item.description)?'hidden':'1px')}}>
                                                        <td width={'10%'}>
                                                            {(++index)}
                                                        </td>
                                                        <td width={'30%'}>
                                                            #{item.indexOrder}
                                                        </td>
                                                        <td width={'60%'}>
                                                            <span>{item.serialCode}</span>
                                                        </td>
                                                    </tr>
                                                </>
                                            ))
                                        }
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        )
    }
}

RectifierControllerSerialNumberInfoModal.propTypes = {
    inspection:PropTypes.object.isRequired,
    showing:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired
}
